module.exports = __webpack_public_path__ + "img/Immun_Gray_1280x1010.1bed53cc.jpg";